// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SimulationController = function ($scope, $http, $rootScope, SimulationParams, FakeTimeSettings, gettextCatalog) {
    $scope.createdInvoiceCount = 0;
    $scope.createdInvoices = [];
    $scope.createdInvoicesTotal = 0;
    $scope.jobName = '';

    $scope.params = new SimulationParams();
    $scope.params.From = $rootScope.addNow('M', 0);
    $scope.params.Until = $rootScope.addNow('M', 1);
    $scope.InvoiceTotal = function (invoice) {
        var total = 0;
        for (var i = 0; i < invoice.ItemList.length; ++i) {
            total += invoice.ItemList[i].Quantity * invoice.ItemList[i].PricePerUnit;
        }
        return total;
    };

    $scope.fakeTime = new FakeTimeSettings();

    $scope.cleanAndSimulate = function () {
        $http({ method: 'POST', url: baseUrl + 'api/v1/Simulation/invoiceRun', data: $scope.params }).then(function (response) {
            var data = response.data;
            if (data) {
                $scope.createdInvoices = data;
                $scope.createdInvoiceCount = $scope.createdInvoices.length;
            }
        });
    };

    $scope.runJob = function () {
        if (!$scope.jobName) {
            $rootScope.notifyValidationError();
        } else {
            $http({
                method: 'POST',
                url: baseUrl + 'api/v1/Simulation/runJob',
                params: { 'jobName': $scope.jobName }
            })
            .then(function () {
                $rootScope.notifySuccess();
            });
        }

        $scope.jobName = '';
    };

    $scope.cleanAndStartPrometheusFakeRun = function () {
        $scope.fakeTime.$save();
    };

    $scope.translationDebug = gettextCatalog.debug;
    $scope.switchTranslationDebug = function () {
        $scope.translationDebug = !$scope.translationDebug;
        gettextCatalog.debug = $scope.translationDebug;
        
        var locale = localStorage["culture"];
        if (!locale) {
            locale = $rootScope.defaultLanguage;
        } 
        gettextCatalog.debugPrefix = "[" + locale + "] ";

    }
};
SimulationController.$inject = ['$scope', '$http', '$rootScope', 'SimulationParams', 'FakeTimeSettings', 'gettextCatalog'];
